// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageHeader_wrapper__HUYIm","header":"pageHeader_header__91Qnd","childrenWrapper":"pageHeader_childrenWrapper__8ympf"};